import { ApiProvider } from "@allergy123/api-client/react";
import { authClientFromEnv, createMockAuthClient } from "@allergy123/auth-client";
import { AuthProvider } from "@allergy123/auth-client/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import "./styles.css";

const env = {
  AUTH_AUTHORITY: import.meta.env.VITE_AUTH_AUTHORITY as string | undefined,
  AUTH_CLIENT_ID: import.meta.env.VITE_AUTH_CLIENT_ID as string | undefined,
  AUTH_MOCK: import.meta.env.VITE_AUTH_MOCK as string | undefined,
};
const apiBaseUrl = (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:8787/v1";

// The synthetic staff persona carries `amr: mfa` so the local API treats it as a multi-factor sign-in (ADR 0011).
const clientPromise =
  !env.AUTH_AUTHORITY || env.AUTH_MOCK === "1"
    ? Promise.resolve(createMockAuthClient({ user: { sub: "mock-admin", email: "staff@allergy123.com", name: "Mock Staff", groups: ["platform-admin", "catalog-publisher"], amr: "mfa" } }))
    : // The extra scope lets the Security page enrol this staff member's authenticator (it acts on the caller only).
      authClientFromEnv(env, window.location.origin, { scopes: ["openid", "email", "profile", "aws.cognito.signin.user.admin"] });

clientPromise.then((client) => {
  const apiConfig = { baseUrl: apiBaseUrl, token: async () => (await client.getSession())?.idToken ?? null };
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <AuthProvider client={client}>
        <ApiProvider config={apiConfig}>
          <RouterProvider router={router} />
        </ApiProvider>
      </AuthProvider>
    </StrictMode>,
  );
});
